import React, { Component } from "react";
import Navbar from "../navbar/navbar";
import "../home/home.css";
import "../callforpaper/callforpaper.css";
import callforpaper from "./dates.json";

// import instructions from "./instructions.json";
// import { LinkButton2 } from "../button/button";
class Dates extends Component {
	render() {
		return (
			<>
				<div className="header-area">
					<div id="home" className="contact-header-area  bg_cover">
						<Navbar />
						<div className=" d-flex align-items-center">
							<div className="container">
								<div className="row justify-content-center">
									<div className="col-lg-10">
										<div className="header-content text-center">
											<h2 className="header-title2">Dates</h2>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				{/* <div className="container">
                    <p className="callforpapertext text-justify">
                        K. C. College of Engineering and Management Studies and Research,
                        Thane one of the pioneer institutions in the field of Engineering,
                        Research and Technology, is organizing its First International
                        Conference on Intelligent Systems for Human Machine
                        Collaboration-2021 (ICISHMC’21) to bring together Professionals,
                        Academicians, Industry Experts, Researchers and Enthusiasts to
                        discuss various emerging trends and innovations, share research
                        results and new directions in the field of Human Machine
                        Collaboration (HMC) over intelligent systems. This technical
                        conference aims at providing a platform for industry and academia
                        for sharing advancements in research and development in upcoming
                        areas of Information Technology. Authors are cordially invited to
                        submit paper through on line paper submission process (Easy Chair
                        submission system) before 1 st July 2021
                    </p>
                </div> */}

				{/* <div className="container callforpapertext-instruction">
                    <p className="callforpapertext-title-semi">
                        Instructions For Authors
                    </p>
                    <h5>Coming Soon...</h5>
                    <ol>
            {instructions &&
              instructions.map((a, key) => (
                <li className="callforpaperlist">{a}</li>
              ))}
          </ol>
                    <div className="submit-paper-btn">
						<LinkButton2 label="Submit the Paper" link="/submit" />
					</div>
                </div> */}

				{/* <div className="container callforpapertext-instruction">
          <p className="callforpapertext-title-semi">Copy Right Form</p>
          <p className="callforpapertext-2 ">
            In order to publish paper in the conference proceeding, the authors
            are required to submit a signed copyright form for each accepted
            paper during registration.
          </p>
        </div> */}
				<div className="schedule-section row">
					<table className="annoucement-table container">
						<tr className="annoucement-table-header-row">
							<th>Deadline</th>
							<th>Dates </th>
						</tr>
						<tr className="announcement-table-row">
									<td className="annoucement-title">Last date for receiving full paper	</td>
									<td>15th June 2022 
										{/* <p className="dates">(Likely to be extended)</p> */}
									</td>
								</tr>
						{callforpaper &&
							callforpaper.map((a, key) => (
								<tr className="announcement-table-row">

									<td className="annoucement-title">{a?.title}</td>
									<td dangerouslySetInnerHTML={{ __html: a?.date }} />
								</tr>
							))}
					</table>
				</div>
				{/* <div className="container">
                    <p className="callforpapertext-title-semi semi-2">
                        Paper Submission - Coming Soon...
                    </p>
                </div> */}
			</>
		);
	}
}

export default Dates;
